import * as BranchActionTypes from '../actions/branches';

import initialState from './initialState';

import { errorResponseHandler } from '../utils/error-utils';


export default (state=initialState.branches, action) => {

    const { payload, type } = action;
    
    switch(type) {
        case BranchActionTypes.LIST_BRANCHES:
        case BranchActionTypes.LIST_BRANCHES_PENDING:
           return { ...state }

        case BranchActionTypes.LIST_BRANCHES_REJECTED:
           return {...state, ...errorResponseHandler(payload, 'BranchesList') }
        case BranchActionTypes.LIST_BRANCHES_FULFILLED:
           return { ...state, branches: payload.data }

        case BranchActionTypes.LIST_REGIONS:
        case BranchActionTypes.LIST_REGIONS_PENDING:
           return { ...state }

        case BranchActionTypes.LIST_REGIONS_REJECTED:
           return {...state, ...errorResponseHandler(payload, 'RegionsList') }

        case BranchActionTypes.LIST_REGIONS_FULFILLED:
           return { ...state, regions: payload.data }


        case BranchActionTypes.CREATE_BRANCH_PENDING:
            return { ...state, isCreatingBranch: true }

        case BranchActionTypes.CREATE_BRANCH_REJECTED:
            return { ...state, isCreatingBranch: false, ...errorResponseHandler(payload, 'CreateBranch') }

        case BranchActionTypes.CREATE_BRANCH_FULFILLED:
            let createdBranch=payload.data;
            return Object.assign({}, state, {
                branches:[
                    createdBranch,
                    ...state.branches
                ],
                successBranchCreate: true,
                successMessage: 'Branch Created'
            })
            //return { ...state, branch_creating: false, successBranchCreate: true, successMessage: 'Branch Created' }

       
       
        case BranchActionTypes.UPDATE_BRANCH:
        case BranchActionTypes.UPDATE_BRANCH_PENDING:
            return { ...state }
    
        case BranchActionTypes.UPDATE_BRANCH_REJECTED:
            return {...state, ...errorResponseHandler(payload, 'BranchUpdate') }
    
        case BranchActionTypes.UPDATE_BRANCH_FULFILLED:
            let updatedBranch=payload.data;
            return Object.assign({}, state, {
                branches:[
                    updatedBranch,
                    ...state.branches
                ],
                successBranchForm: true,
                successMessage: 'Branch Updated'
            })
            //return { ...state, branch_updating: false, successBranchForm: true, successMessage: 'Branch Updated' }
    
            default:
                return state
    }
}




// WEBPACK FOOTER //
// ./src/reducers/branches.js